/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_No_Properties_ErrorInputs */



/**
* | output |
* | --- |
* | "Select at least one property to sync." |
*
* @param {Event_Group_Sync_No_Properties_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_no_properties_error = /** @type {((inputs?: Event_Group_Sync_No_Properties_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_No_Properties_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Select at least one property to sync.")
	return /** @type {LocalizedString} */ ("Select at least one property to sync.")
});